/**
 * Cores de interfaces que **não são nossas**, desenhadas nos mockups da home.
 *
 * O demo do hero imita o WhatsApp Web dentro de um aparelho. Essas cores copiam
 * o tema escuro do WhatsApp e o acabamento de um notebook/celular — não entram
 * no tema da Tãmi e não devem ser usadas fora de mockup. Moram aqui, e não
 * escritas na tela, para seguir a regra de nenhuma cor literal em app e para
 * deixar o motivo escrito num lugar só.
 */

/** Tema escuro do WhatsApp Web. */
export const WHATSAPP = {
  /** Fundo da conversa e da barra de digitação. */
  chat: "#0B141A",
  /** Lista de conversas, à esquerda. */
  sidebar: "#111B21",
  /** Cabeçalhos, balão recebido, campo de busca e de digitação. */
  panel: "#202C33",
  /** Selo de data no meio da conversa. */
  chip: "#182229",
  /** Conversa selecionada na lista. */
  active: "#2A3942",
  /** Balão enviado. */
  bubbleOut: "#005C4B",
  text: "#E9EDEF",
  textMuted: "#8696A0",
  icon: "#AEBAC1",
  /** Horário dentro do balão: branco a 65%. */
  timestamp: "#FFFFFFA6",
  /** Dois tiques azuis de lida. */
  readTick: "#53BDEB",
  /** Botão do microfone. */
  send: "#00A884",
  /** Verde de destaque: não lidas, filtro ativo, botões redondos. */
  accent: "#21C063",
  /** Fundo do filtro ativo. */
  accentMuted: "#103629",
  /** Rabiscos do papel de parede: branco em opacidade quase nula. */
  doodle: "#FFFFFF",
} as const;

/** Cor de avatar dos contatos fictícios da lista de conversas. */
export const WHATSAPP_AVATARS = {
  blue: "#3B5BDB",
  teal: "#0CA678",
  orange: "#E8590C",
  violet: "#7048E8",
  amber: "#F08C00",
} as const;

/** Acabamento do aparelho em volta do demo (celular e notebook). */
export const DEVICE = {
  /** Moldura do celular e do tablet; barra de endereço do navegador. */
  bezel: "#161616",
  /** Câmera frontal do celular. */
  camera: "#3A3A3A",
  /** Borda interna da tela do notebook. */
  screenBorder: "#0A0A0B",
  /** Webcam do notebook. */
  webcam: "#161618",
  /** Barra de título da janela do navegador. */
  toolbar: "#232323",
  /** Esqueleto de carregamento do demo. */
  skeleton: "#111111",
  /** Tampa do notebook, de cima para baixo. */
  lid: ["#2B2B2E", "#1D1D20", "#252528"],
  /** Base do notebook, de cima para baixo; o meio é translúcido (`50`). */
  base: ["#242427", "#15151750", "#2A2A2D"],
  /** Semáforo da janela do macOS. */
  trafficLights: { close: "#FF5F57", minimize: "#FEBC2E", zoom: "#28C840" },
} as const;
